import ISelectItem from "@app/interfaces/dtos/ISelectItem";

export const sortSelectItems = (items: ISelectItem[]): ISelectItem[] => {
	return [...items];
};
